import React from "react"
import Helmet from "react-helmet"

import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import Layout from "../components/layout/layout.js"
import Seo from "../components/seo"
import PageSection from "../components/pageSection/pageSection.js"
import SharedFooter from "../components/sharedFooter/sharedFooter.js"
import { HeroSection } from "../components/homeSections/hero/hero.js"
import { PressBannerSection } from "../components/homeSections/pressBanner/pressBanner.js"
import { BankingFeesSection } from "../components/homeSections/bankingFees/bankingFees.js"
import { HowTillWorksSection } from "../components/homeSections/howTillWorks/howTillWorks.js"
import { SmarterSpenderSection } from "../components/homeSections/smarterSpender/smarterSpender.js"
import { TillEffectSection } from "../components/homeSections/tillEffect/tillEffect.js"
import { PassportToSpendingSection } from "../components/homeSections/passportToSpending/passportToSpending.js"
import { NoFeesSection } from "../components/homeSections/noFees/noFees.js"
import { WaitlistModalProvider } from "../components/waitlistModal/waitlistModalContext.js"

import { getQueryParamValueByName } from "../utils/query_params.js"
import { getDevice } from "../utils/getDevice.js"

const description = "Till is a FREE app and debit card for kids built for families to help kids become smarter spenders."

const IndexPage = () => {

  const data = useStaticQuery(graphql`
    query {
      fullWidthHome: file(relativePath: { eq: "home/full-width-home.jpg" }) {
        childImageSharp {
          gatsbyImageData (
            width: 1440
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
      tillLogo: file(relativePath: { eq: "TillFinancial.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 586
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  `)

  const root = "https://tillfinancial.io";
  const ccCode = getQueryParamValueByName("campaignCode") ? getQueryParamValueByName("campaignCode") : undefined;
  const [device, setDevice] = React.useState("");

  React.useEffect(() => {
    const d = getDevice();
    setDevice(d);
  }, []);

  return (
    <WaitlistModalProvider>
      <Layout useWhiteHeaderBg={false}>
        <Seo
          title="Till: Free App & Debit Card for Kids "
          description={description}
        />
        <Helmet>
          <script type="application/ld+json">{`
            {
              "url": "`+ root + `",
              "logo": "` + root + getImage(data.tillLogo).images.fallback.src + `",
              "name": "Till",
              "@type": "Corporation",
              "sameAs": [
                  "https://www.facebook.com/tillfinancial/",
                  "https://www.youtube.com/channel/UCCFxi_vyNbTUTWgMOHaLz6w",
                  "https://twitter.com/tillfinancial/",
                  "instagram.com/tillfinancial"
              ],
              "@context": "https://schema.org",
              "alternateName": "Till Financial"
            }
          `}</script>
        </Helmet>
        <div tabindex="0">
          <HeroSection />

          <PressBannerSection />

          <BankingFeesSection ccCode={ccCode} device={device} />

          <HowTillWorksSection />

          <SmarterSpenderSection />

          <PassportToSpendingSection ccCode={ccCode} device={device} />

          <TillEffectSection />

          <section style={{ backgroundColor: "#eff3f9" }}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <GatsbyImage
                image={getImage(data.fullWidthHome)}
                alt="Teenager holding a Till debit card and a phone showing the home screen of the Till financial app"
                width={1440}
              />
            </div>
          </section>

          <NoFeesSection />
        </div>
      </Layout>
      <PageSection backgroundColor="#eff3f9">
        <SharedFooter ccCode={ccCode} device={device} />
      </PageSection>
    </WaitlistModalProvider>
  )
}

export default IndexPage
